export default {
     invitationCode: '',
     userDetails: ''
};